interface Project {
    id: number;
    name: string;
}

interface SubProject {
    id: number;
    name: string;
}

interface WorkType {
    id: number;
    name: string;
}

interface Lead {
    id: string;
    name: string;
}

interface WorkLocation {
    id: number;
    name: string;
}

interface SkillSet {
    id: number;
    name: string;
    potential_score: number;
    current_score: number;
}

export interface IEmpProfDetails {
    id: number;
    employee_id: string;
    project: Project | {};
    sub_projects: SubProject[];
    work_types: WorkType[];
    leads: Lead[];
    work_location: WorkLocation | {};
    skill_sets: SkillSet[];
    access_level: string;
    employee_module_access_levels: any[]; // You can define a specific type for this if possible
}



export enum ISingleEmployProfActionTypes {
    FETCH_EMP_PROF_DETAILS_LIST_REQUEST = 'FETCH_EMP_PROF_DETAILS_LIST_REQUEST',
    FETCH_EMP_PROF_DETAILS_LIST_SUCCESS = 'FETCH_EMP_PROF_DETAILS_LIST_SUCCESS',
    FETCH_EMP_PROF_DETAILS_LIST_FAILURE = 'FETCH_EMP_PROF_DETAILS_LIST_FAILURE',

}

export type ISingleEmployProfActionCreator = {
    type: string;
    payload: IEmpProfDetails;
  };
